import {
  Tabs as RATabs,
  TabList as RATabList,
  Tab as RATab,
  TabPanel as RATabPanel,
  TabsProps,
  TabProps,
  TabListProps,
  TabPanelProps,
} from "react-aria-components";
import {
  tabListStyles,
  tabPanelStyles,
  tabsStyles,
  tabStyles,
} from "./tabs.css";
import { ReactNode } from "react";

export const TabsWrapper = ({ children, ...props }: TabsProps) => (
  <RATabs className={tabsStyles} {...props}>
    {children}
  </RATabs>
);

export const Tab = ({ id, children, ...props }: TabProps) => (
  <RATab id={id} className={tabStyles} {...props}>
    {children}
  </RATab>
);

export const TabPanel = ({ id, children, ...props }: TabPanelProps) => (
  <RATabPanel id={id} className={tabPanelStyles} {...props}>
    {children}
  </RATabPanel>
);

export const TabList = ({
  children,
  ...props
}: TabListProps<{ id: string; children: ReactNode }>) => (
  <RATabList className={tabListStyles} {...props}>
    {children}
  </RATabList>
);
